import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';
import { CABIN_CREW_BUS_ASSIGNMENT_PATH } from '../../../../config/paths';
import CabinCrewBusAssignmentForm from './CabinCrewBusAssignmentForm';
import Content from '../../../layout/Content';
import { postCabinCrewBusAssign } from '../../../../actions/traffic/CabinCrewBusAssignment';

export class NewCabinCrewBusAssignment extends Component {
  onSubmit = (formValues) => {
    const { dispatchPostCabinCrewBusAssign } = this.props;
    const cabinCrewListLength = formValues.cabinCrewList.length;
    const newFormValues = {
      busId: formValues.bus.value,
      companyBusId: formValues.bus.label,
      cabinCrewId: formValues.cabinCrewList[cabinCrewListLength - 1].cabinCrew.value,
    };
    dispatchPostCabinCrewBusAssign(newFormValues);
  };

  render() {
    return (
      <Content
        breadcrumbs={this.props.breadcrumbs}
        title="Nueva Asignación de Servicio a Bordo"
        subtitle="Nueva asignación de tripulantes"
        content={<CabinCrewBusAssignmentForm onSubmit={this.onSubmit} />}
      />
    );
  }
}

const mapStateToProps = ({ TrafficUnit }) => ({
  breadcrumbs: [
    ...TrafficUnit.CabinCrewUnitHome.get('breadcrumbs'),
    {
      text: 'Asignaciones de Servicio a Bordo',
      href: CABIN_CREW_BUS_ASSIGNMENT_PATH,
    },
    {
      text: 'Nuevo',
      href: '',
    },
  ],
});

const mapDispatchToProps = { dispatchPostCabinCrewBusAssign: postCabinCrewBusAssign };

NewCabinCrewBusAssignment.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  dispatchPostCabinCrewBusAssign: PropTypes.func.isRequired,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(NewCabinCrewBusAssignment);